import styled from "styled-components";
import DownloadBG from "../../../assets/images/backGrounds/downloadSectionBG.webp";
export const Styles = styled.div`
  #downloadSection {
    position: relative;
    background-image: url(${DownloadBG});
    background-size: 100% 80%;
    background-repeat: no-repeat;
    height: 500px;
    display: flex;
    align-items: center;
  }
  #downloadSection .bg {
    position: absolute;
    width: 100%;
    height: 95%;
  }
  #downloadSection .bg img {
    width: 100%;
    height: 100%;
  }

  #downloadSection .section-data {
    margin-bottom: 20%;
    text-align: center;
  }
  #downloadSection .section-decription {
    color: #fff;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 40px;
  }
  #downloadSection .download-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  #downloadSection .download-buttons a {
    width: 180px;
    height: 53px;
    transition: 0.3s;
  }
  
  #downloadSection .download-buttons a img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all.3s;
  }
  #downloadSection .download-buttons a:hover img {
    opacity: 0.7;
  }
  #downloadSection .section-img {
    width: 100%;
    height: 440px;
  }
  #downloadSection .section-img img {
    width: 100%;
    height: 440px;
    object-fit: contain;
  }
  @media (max-width: 992px) {
    #downloadSection{
      margin-bottom: 200px;
    }
    #downloadSection .section-img {
      /* width: 400px;
      height: 250px; */
    }
    /* #downloadSection .section-img img {
      max-width: 100%;
      max-height: 440px;
      object-fit: contain;
    } */
    #downloadSection .section-data {
      margin-top: 50px;
      margin-bottom: 0;
    }
    #downloadSection .section-img {
      margin-top: 20px;
      margin-bottom: -200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 768px) {
   
    #downloadSection .section-data .title ,#downloadSection .section-data  .description {
      font-size: 15px;
    }
  }
`;
